module.exports = __webpack_public_path__ + "static/media/Enterprise.e57735d1.png";